/**
 * Dashboard v2 - Gestione gridstack, edit mode, salvataggio layout, widget picker.
 * Dipende da: jQuery, GridStack (globali da bootstrap.js), window.DashboardV2Config (dalla view).
 */
(function () {
    var MAX_CONFIG_RETRIES = 50;
    var configRetries = 0;

    function init() {
        if (typeof $ === 'undefined') {
            return;
        }
        var $gridEl = $('#dashboard-v2-grid');
        if (!$gridEl.length) {
            return;
        }
        if (typeof window.DashboardV2Config === 'undefined') {
            if (configRetries++ < MAX_CONFIG_RETRIES) {
                setTimeout(init, 150);
            }
            return;
        }

        var config = window.DashboardV2Config;
        var isEditMode = false;
        var grid = null;
        var layoutSnapshotAtEditStart = null;

        // null = aggiunta alla griglia principale
        // { widgetId: string, tabIndex: number } = aggiunta dentro un tab specifico
        var tabPickerContext = null;

        function initGrid() {
            grid = GridStack.init({
                column: 12,
                animate: true,
                staticGrid: true,
                handle: '.dashboard-v2-widget-heading',
                cellHeight: 10,
                verticalMargin: 10,
                float: false
            }, '#dashboard-v2-grid');
        }

        function doExitEditMode() {
            isEditMode = false;
            layoutSnapshotAtEditStart = null;
            if (grid) {
                grid.setStatic(true);
            }
            $('#dashboard-v2-toggle-edit .btn-edit-label').text('Personalizza');
            $('#dashboard-v2-save-layout').hide();
            $('#dashboard-v2-add-widget-fab').hide();
            $('.dashboard-v2-widget-remove').hide();
            $('.dashboard-v2-tab-add-li').hide();
            $('.dashboard-v2-tab-add-widget-wrap').hide();
            $('.dashboard-v2-tab-widget-remove').hide();
            $('.chatCallout').show();
            autoResizeWidgets();
        }

        function toggleEditMode() {
            if (isEditMode) {
                var current = JSON.stringify(serializeLayout());
                if (current !== layoutSnapshotAtEditStart && typeof Swal !== 'undefined') {
                    Swal.fire({
                        title: 'Modifiche non salvate',
                        text: 'Hai modificato il layout senza salvare. Uscire comunque?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Esci',
                        cancelButtonText: 'Annulla'
                    }).then(function (result) {
                        if (result.isConfirmed) {
                            doExitEditMode();
                        }
                    });
                    return;
                }
                doExitEditMode();
                return;
            }

            isEditMode = true;
            layoutSnapshotAtEditStart = JSON.stringify(serializeLayout());
            if (grid) {
                grid.setStatic(false);
            }
            $('#dashboard-v2-toggle-edit .btn-edit-label').text('Esci da personalizzazione');
            $('#dashboard-v2-save-layout').show();
            $('#dashboard-v2-add-widget-fab').show();
            $('.dashboard-v2-widget-remove').show();
            $('.dashboard-v2-tab-add-li').show();
            $('.dashboard-v2-tab-add-widget-wrap').show();
            $('.dashboard-v2-tab-widget-remove').show();
            $('.chatCallout').hide();
        }

        // ==================== Serializzazione layout ====================

        function readTabDataFromDom($gridItem) {
            var tabs = [];
            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            if (!$container.length) {
                return tabs;
            }
            $container.find('.tab-pane').each(function () {
                var $pane = $(this);
                var $navLink = $container.find('a[href="#' + $pane.attr('id') + '"] .dashboard-v2-tab-label');
                var name = $navLink.length ? $navLink.text().trim() : 'Tab';
                var widgets = [];
                $pane.find('.dashboard-v2-tab-widget').each(function () {
                    var t = $(this).attr('data-widget-type');
                    var w = parseInt($(this).attr('data-widget-w'), 10) || 12;
                    if (t) {
                        widgets.push({ type: t, w: w });
                    }
                });
                tabs.push({ name: name, widgets: widgets });
            });
            return tabs;
        }

        function syncTabData($gridItem) {
            var tabs = readTabDataFromDom($gridItem);
            $gridItem.attr('data-widget-tabs', JSON.stringify(tabs));
        }

        function serializeLayout() {
            var items = [];
            $gridEl.find('.grid-stack-item').each(function () {
                var $item = $(this);
                var node = $item.data('_gridstack_node') || {};
                var id = $item.attr('data-gs-id');
                var type = $item.attr('data-widget-type');
                if (!id || !type) {
                    return;
                }
                var obj = {
                    id: id,
                    type: type,
                    x: node.x !== undefined ? node.x : (parseInt($item.attr('data-gs-x'), 10) || 0),
                    y: node.y !== undefined ? node.y : (parseInt($item.attr('data-gs-y'), 10) || 0),
                    w: node.width !== undefined ? node.width : (parseInt($item.attr('data-gs-width'), 10) || 4),
                    h: node.height !== undefined ? node.height : (parseInt($item.attr('data-gs-height'), 10) || 3)
                };
                if (type === 'tab_container') {
                    obj.tabs = readTabDataFromDom($item);
                }
                items.push(obj);
            });
            return items;
        }

        function saveLayout() {
            var items = serializeLayout();
            $.ajax({
                url: config.saveLayoutUrl,
                method: 'POST',
                data: { _token: config.csrfToken, widgets: items },
                contentType: 'application/x-www-form-urlencoded',
                success: function () {
                    layoutSnapshotAtEditStart = JSON.stringify(serializeLayout());
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'success', title: 'Salvato', text: 'Layout salvato.' });
                    } else if (typeof window.toastr !== 'undefined') {
                        window.toastr.success('Layout salvato.');
                    } else {
                        alert('Layout salvato.');
                    }
                },
                error: function () {
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({ icon: 'error', title: 'Errore', text: 'Errore nel salvataggio del layout.' });
                    } else if (typeof window.toastr !== 'undefined') {
                        window.toastr.error('Errore nel salvataggio.');
                    } else {
                        alert('Errore nel salvataggio del layout.');
                    }
                }
            });
        }

        // ==================== Widget grid principale ====================

        function removeWidget(widgetId) {
            var $item = $gridEl.find('.grid-stack-item[data-gs-id="' + widgetId + '"]');
            if ($item.length && grid) {
                try {
                    // Gridstack 1.x: removeWidget(el, removeDOM=true, triggerEvent=true).
                    // Passare removeDOM=true altrimenti il widget resta visibile al primo click
                    // (veniva tolto solo dall'engine logico e sembrava che il click non avesse effetto).
                    grid.removeWidget($item.get(0), true);
                } catch (e) {
                    $item.remove();
                }
            }
        }

        function addWidgetToGrid(widgetId, widgetType, w, h) {
            var def = config.widgetCatalog[widgetType];
            if (!def) {
                return;
            }
            var url = typeof getWidgetFetchUrl === 'function' ? getWidgetFetchUrl(widgetType) : config.widgetHtmlUrl.replace('__ID__', widgetType);
            if (typeof getWidgetFetchUrl !== 'function' && config.filterParams && config.filterParams.ws) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + 'ws=' + encodeURIComponent(config.filterParams.ws);
            }
            $.get(url, function (data) {
                if (!data.html) {
                    return;
                }
                var nextY = 0;
                $gridEl.find('.grid-stack-item').each(function () {
                    var node = $(this).data('_gridstack_node') || {};
                    var bottom = (node.y || 0) + (node.height || 1);
                    if (bottom > nextY) {
                        nextY = bottom;
                    }
                });
                var newId = 'w_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                var name = def.name || widgetType;
                var icon = def.icon || 'fa-square';
                var html = '<div class="grid-stack-item-content">' +
                    '<div class="panel panel-info dashboard-v2-widget-panel">' +
                    '<div class="panel-heading dashboard-v2-widget-heading" style="display: flex; justify-content: space-between; align-items: center;">' +
                    '<span><i class="fa ' + icon + '"></i> ' + name + '</span>' +
                    '<button type="button" class="btn btn-danger btn-xs dashboard-v2-widget-remove" data-widget-id="' + newId + '" title="Rimuovi widget"><i class="fa fa-times"></i></button>' +
                    '</div>' +
                    '<div class="panel-body" style="padding: 15px 0 0 0;">' + data.html + '</div>' +
                    '</div>' +
                    '</div>';
                var $newEl = $('<div class="grid-stack-item" data-gs-id="' + newId + '" data-widget-type="' + widgetType + '">' + html + '</div>');
                if (grid) {
                    grid.addWidget($newEl.get(0), { x: 0, y: nextY, width: w, height: h, autoPosition: false });
                }
                $newEl.find('.dashboard-v2-widget-remove').on('click', function () {
                    removeWidget(newId);
                });
                if (window.chartsHandler && typeof window.chartsHandler.initializeCharts === 'function') {
                    window.chartsHandler.initializeCharts();
                }
                if (typeof window.mountDashboardMyBrainIn === 'function') {
                    var $nb = $newEl.find('.panel-body').first();
                    if ($nb.length) {
                        window.mountDashboardMyBrainIn($nb[0]);
                    }
                }
                setTimeout(autoResizeWidgets, 300);
                setTimeout(autoResizeWidgets, 1500);
            }).fail(function () {
                if (typeof window.toastr !== 'undefined') {
                    window.toastr.error('Impossibile caricare il widget.');
                } else {
                    alert('Impossibile caricare il widget.');
                }
            });
        }

        // ==================== Tab Container ====================

        function addEmptyTabContainer() {
            var defaultTabs = [
                { name: 'Tab 1', widgets: [] },
                { name: 'Tab 2', widgets: [] },
                { name: 'Tab 3', widgets: [] }
            ];
            var url = typeof getWidgetFetchUrl === 'function' ? getWidgetFetchUrl('tab_container') : config.widgetHtmlUrl.replace('__ID__', 'tab_container');
            $.ajax({
                url: url,
                method: 'POST',
                data: { _token: config.csrfToken, tabs: defaultTabs },
                success: function (data) {
                    if (!data.html) {
                        return;
                    }
                    var nextY = 0;
                    $gridEl.find('.grid-stack-item').each(function () {
                        var node = $(this).data('_gridstack_node') || {};
                        var bottom = (node.y || 0) + (node.height || 1);
                        if (bottom > nextY) {
                            nextY = bottom;
                        }
                    });
                    var newId = 'w_' + Date.now() + '_tab';
                    var def = config.widgetCatalog['tab_container'] || {};
                    var name = def.name || 'Modulo Tab';
                    var icon = def.icon || 'fa-folder-o';
                    var html = '<div class="grid-stack-item-content">' +
                        '<div class="panel panel-info dashboard-v2-widget-panel">' +
                        '<div class="panel-heading dashboard-v2-widget-heading" style="display: flex; justify-content: space-between; align-items: center;">' +
                        '<span><i class="fa ' + icon + '"></i> ' + name + '</span>' +
                        '<button type="button" class="btn btn-danger btn-xs dashboard-v2-widget-remove" data-widget-id="' + newId + '" title="Rimuovi widget"><i class="fa fa-times"></i></button>' +
                        '</div>' +
                        '<div class="panel-body" style="padding: 15px 0 0 0;">' + data.html + '</div>' +
                        '</div>' +
                        '</div>';
                    var tabsJson = JSON.stringify(defaultTabs).replace(/"/g, '&quot;');
                    var $newEl = $('<div class="grid-stack-item" data-gs-id="' + newId + '" data-widget-type="tab_container" data-widget-tabs="' + tabsJson + '">' + html + '</div>');
                    if (grid) {
                        grid.addWidget($newEl.get(0), { x: 0, y: nextY, width: 12, height: 25, autoPosition: false });
                    }
                    $newEl.find('.dashboard-v2-widget-remove').on('click', function () {
                        removeWidget(newId);
                    });
                    if (isEditMode) {
                        $newEl.find('.dashboard-v2-tab-add-li').show();
                        $newEl.find('.dashboard-v2-tab-add-widget-wrap').show();
                    }
                    setTimeout(autoResizeWidgets, 300);
                    setTimeout(autoResizeWidgets, 1500);
                    $('#dashboard-v2-widget-picker-modal').modal('hide');
                },
                error: function () {
                    if (typeof window.toastr !== 'undefined') {
                        window.toastr.error('Impossibile creare il modulo tab.');
                    } else {
                        alert('Impossibile creare il modulo tab.');
                    }
                }
            });
        }

        function addNewTab($container) {
            var $gridItem = $container.closest('.grid-stack-item');
            var tabWidgetId = $container.attr('data-tab-widget-id');
            var tabCount = $container.find('.tab-pane').length;
            var newIndex = tabCount;
            var newName = 'Tab ' + (newIndex + 1);
            var paneId = tabWidgetId + '_tab_' + newIndex;

            var $addLi = $container.find('.dashboard-v2-tab-add-li');
            var $newLi = $('<li role="presentation"><a href="#' + paneId + '" role="tab" data-toggle="tab"><span class="dashboard-v2-tab-label">' + newName + '</span></a></li>');
            $addLi.before($newLi);

            var showAdd = isEditMode ? '' : 'display: none; ';
            var $newPane = $(
                '<div role="tabpanel" class="tab-pane" id="' + paneId + '" data-tab-index="' + newIndex + '">' +
                '<div class="row dashboard-v2-tab-widgets-row"></div>' +
                '<div class="dashboard-v2-tab-add-widget-wrap" style="' + showAdd + 'text-align: center; padding: 15px 0;">' +
                '<button type="button" class="btn btn-default btn-sm dashboard-v2-tab-add-widget" data-tab-index="' + newIndex + '">' +
                '<i class="fa fa-plus"></i> Aggiungi widget a questo tab</button></div>' +
                '</div>'
            );
            $container.find('.tab-content').append($newPane);
            $newLi.find('a').tab('show');
            syncTabData($gridItem);
        }

        function removeTabWidget($btn) {
            var $widget = $btn.closest('.dashboard-v2-tab-widget');
            var $gridItem = $widget.closest('.grid-stack-item');
            $widget.remove();
            syncTabData($gridItem);
            setTimeout(autoResizeWidgets, 200);
        }

        function renameTab($label) {
            var currentName = $label.text().trim();
            var $input = $('<input type="text" class="form-control input-sm dashboard-v2-tab-rename-input" style="display: inline-block; width: 120px; height: 22px; padding: 1px 4px; font-size: 12px;">');
            $input.val(currentName);
            $label.hide().after($input);
            $input.focus().select();

            function commitRename() {
                var newName = $input.val().trim() || currentName;
                $label.text(newName).show();
                $input.remove();
                var $gridItem = $label.closest('.grid-stack-item');
                if ($gridItem.length) {
                    syncTabData($gridItem);
                }
            }

            $input.on('blur', commitRename);
            $input.on('keydown', function (e) {
                if (e.which === 13) {
                    commitRename();
                }
                if (e.which === 27) {
                    $label.show();
                    $input.remove();
                }
            });
        }

        // ==================== Widget Picker ====================

        function switchPickerCategory(category) {
            var $modal = $('#dashboard-v2-widget-picker-modal');
            $modal.find('.dashboard-v2-picker-sidebar li').removeClass('active');
            $modal.find('.dashboard-v2-picker-cat-link[data-category="' + category + '"]').closest('li').addClass('active');
            $modal.find('.dashboard-v2-picker-panel').hide();
            $modal.find('.dashboard-v2-picker-panel[data-panel="' + category + '"]').show();
        }

        function getExistingWidgetTypes() {
            var types = {};
            $gridEl.find('.grid-stack-item').each(function () {
                var t = $(this).attr('data-widget-type');
                if (t) {
                    types[t] = true;
                }
            });
            return types;
        }

        function getExistingTabWidgetTypes($gridItem, tabIndex) {
            var types = {};
            var $pane = $gridItem.find('.tab-pane[data-tab-index="' + tabIndex + '"]');
            $pane.find('.dashboard-v2-tab-widget').each(function () {
                var t = $(this).attr('data-widget-type');
                if (t) {
                    types[t] = true;
                }
            });
            return types;
        }

        function openWidgetPicker() {
            tabPickerContext = null;
            var $modal = $('#dashboard-v2-widget-picker-modal');
            var existing = getExistingWidgetTypes();
            $modal.find('.dashboard-v2-picker-checkbox').each(function () {
                $(this).prop('checked', !!existing[$(this).val()]);
            });
            $modal.find('.dashboard-v2-picker-cat-link[data-category="tab_creator"]').closest('li').show();
            var firstCat = $modal.find('.dashboard-v2-picker-cat-link').first().attr('data-category');
            if (firstCat) {
                switchPickerCategory(firstCat);
            }
            $modal.find('.modal-title').html('<i class="fa fa-th-large"></i> Aggiungi widget');
            $modal.modal('show');
        }

        function openTabWidgetPicker(gridItemId, tabIndex) {
            tabPickerContext = { widgetId: gridItemId, tabIndex: tabIndex };
            var $gridItem = $gridEl.find('.grid-stack-item[data-gs-id="' + gridItemId + '"]');
            var existing = getExistingTabWidgetTypes($gridItem, tabIndex);
            var $modal = $('#dashboard-v2-widget-picker-modal');
            $modal.find('.dashboard-v2-picker-checkbox').each(function () {
                $(this).prop('checked', !!existing[$(this).val()]);
            });
            $modal.find('.dashboard-v2-picker-cat-link[data-category="tab_creator"]').closest('li').hide();
            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            var $pane = $container.find('.tab-pane[data-tab-index="' + tabIndex + '"]');
            var tabName = $container.find('a[href="#' + $pane.attr('id') + '"] .dashboard-v2-tab-label').text().trim() || ('Tab ' + (tabIndex + 1));
            var firstCat = $modal.find('.dashboard-v2-picker-cat-link:visible').first().attr('data-category');
            if (firstCat) {
                switchPickerCategory(firstCat);
            }
            $modal.find('.modal-title').html('<i class="fa fa-th-large"></i> Aggiungi widget a: <strong>' + tabName + '</strong>');
            $modal.modal('show');
        }

        function addSelectedWidgets() {
            if (tabPickerContext) {
                addSelectedWidgetsToTab();
            } else {
                addSelectedWidgetsToGrid();
            }
        }

        function addSelectedWidgetsToGrid() {
            var existing = getExistingWidgetTypes();
            var toAdd = [];
            var toRemove = [];
            $('#dashboard-v2-widget-picker-modal .dashboard-v2-picker-checkbox').each(function () {
                var type = $(this).val();
                var checked = $(this).is(':checked');
                if (checked && !existing[type]) {
                    var $row = $(this).closest('.dashboard-v2-picker-widget');
                    var w = parseInt($row.find('.dashboard-v2-picker-width').val(), 10) || 4;
                    var h = parseInt($row.attr('data-widget-h'), 10) || 3;
                    toAdd.push({ type: type, w: Math.min(12, Math.max(1, w)), h: h });
                } else if (!checked && existing[type]) {
                    toRemove.push(type);
                }
            });
            toRemove.forEach(function (type) {
                $gridEl.find('.grid-stack-item[data-widget-type="' + type + '"]').each(function () {
                    var id = $(this).attr('data-gs-id');
                    if (id) {
                        removeWidget(id);
                    }
                });
            });
            toAdd.forEach(function (item, idx) {
                var def = config.widgetCatalog[item.type];
                if (!def) {
                    return;
                }
                addWidgetToGrid('w_' + Date.now() + '_' + idx, item.type, item.w, item.h);
            });
            if (toAdd.length === 0 && toRemove.length === 0) {
                return;
            }
            $('#dashboard-v2-widget-picker-modal').modal('hide');
        }

        function addSelectedWidgetsToTab() {
            var ctx = tabPickerContext;
            if (!ctx) {
                return;
            }
            var $gridItem = $gridEl.find('.grid-stack-item[data-gs-id="' + ctx.widgetId + '"]');
            if (!$gridItem.length) {
                return;
            }
            var existing = getExistingTabWidgetTypes($gridItem, ctx.tabIndex);
            var toAdd = [];
            var toRemove = [];
            $('#dashboard-v2-widget-picker-modal .dashboard-v2-picker-checkbox').each(function () {
                var type = $(this).val();
                var checked = $(this).is(':checked');
                if (checked && !existing[type]) {
                    var $row = $(this).closest('.dashboard-v2-picker-widget');
                    var w = parseInt($row.find('.dashboard-v2-picker-width').val(), 10) || 4;
                    toAdd.push({ type: type, w: Math.min(12, Math.max(1, w)) });
                } else if (!checked && existing[type]) {
                    toRemove.push(type);
                }
            });

            var $container = $gridItem.find('.dashboard-v2-tab-container').first();
            var $pane = $container.find('.tab-pane[data-tab-index="' + ctx.tabIndex + '"]');
            var $widgetsRow = $pane.find('.dashboard-v2-tab-widgets-row').first();

            toRemove.forEach(function (type) {
                $widgetsRow.find('.dashboard-v2-tab-widget[data-widget-type="' + type + '"]').remove();
            });

            if (toAdd.length === 0 && toRemove.length === 0) {
                return;
            }

            if (toAdd.length > 0) {
                var queue = toAdd.slice();
                function processNext() {
                    if (queue.length === 0) {
                        syncTabData($gridItem);
                        setTimeout(autoResizeWidgets, 300);
                        setTimeout(autoResizeWidgets, 1500);
                        $('#dashboard-v2-widget-picker-modal').modal('hide');
                        return;
                    }
                    var item = queue.shift();
                    var url = getWidgetFetchUrl(item.type);
                    $.get(url, function (data) {
                        if (data.html) {
                            var showRemove = isEditMode ? '' : 'display: none; ';
                            var removeBtn = '<button type="button" class="btn btn-danger btn-xs dashboard-v2-tab-widget-remove" ' +
                                'style="' + showRemove + 'position: absolute; top: 2px; right: 17px; z-index: 10;" title="Rimuovi">' +
                                '<i class="fa fa-times"></i></button>';
                            var $widget = $('<div class="col-md-' + item.w + ' dashboard-v2-tab-widget" ' +
                                'data-widget-type="' + item.type + '" data-widget-w="' + item.w + '" ' +
                                'style="margin-bottom: 15px; position: relative;">' +
                                removeBtn + data.html + '</div>');
                            $widgetsRow.append($widget);
                            if (typeof window.mountDashboardMyBrainIn === 'function') {
                                window.mountDashboardMyBrainIn($widget[0]);
                            }
                        }
                        processNext();
                    }).fail(processNext);
                }
                processNext();
            } else {
                syncTabData($gridItem);
                setTimeout(autoResizeWidgets, 300);
                $('#dashboard-v2-widget-picker-modal').modal('hide');
            }
        }

        // ==================== Auto resize ====================

        function autoResizeWidgets() {
            if (!grid) {
                return;
            }
            var cellH = 10;
            var margin = 10;
            var unitH = cellH + margin;

            $gridEl.find('.grid-stack-item').each(function () {
                var $item = $(this);
                var $content = $item.children('.grid-stack-item-content');
                var $panel = $item.find('.dashboard-v2-widget-panel');
                if (!$panel.length || !$content.length) {
                    return;
                }

                var contentEl = $content[0];
                var savedPos = contentEl.style.position;
                var savedTop = contentEl.style.top;
                var savedBottom = contentEl.style.bottom;
                contentEl.style.position = 'static';
                contentEl.style.top = 'auto';
                contentEl.style.bottom = 'auto';

                var naturalHeight = $panel[0].offsetHeight;

                contentEl.style.position = savedPos;
                contentEl.style.top = savedTop;
                contentEl.style.bottom = savedBottom;

                if (naturalHeight < 20) {
                    return;
                }

                var neededH = Math.max(2, Math.ceil((naturalHeight + margin) / unitH));

                var node = $item.data('_gridstack_node');
                var currentH = node ? node.height : (parseInt($item.attr('data-gs-height'), 10) || 3);

                if (neededH !== currentH) {
                    grid.resize($item.get(0), null, neededH);
                }
            });
        }

        function scheduleAutoResize() {
            autoResizeWidgets();
            setTimeout(autoResizeWidgets, 500);
            setTimeout(autoResizeWidgets, 1500);
            setTimeout(autoResizeWidgets, 3000);
        }

        // ==================== Async Widget Loading ====================

        function getWidgetFetchUrl(widgetType, tabs) {
            var url = config.widgetHtmlUrl.replace('__ID__', widgetType);
            var params = config.filterParams || {};
            var qs = [];
            if (params.company) qs.push('company=' + encodeURIComponent(params.company));
            if (params.year) qs.push('year=' + encodeURIComponent(params.year));
            if (params.group) qs.push('group=' + encodeURIComponent(params.group));
            if (params.ws) qs.push('ws=' + encodeURIComponent(params.ws));
            if (qs.length) url += (url.indexOf('?') >= 0 ? '&' : '?') + qs.join('&');
            return url;
        }

        function loadWidgetAsync($body, widgetType, widgetId, tabs) {
            var url = getWidgetFetchUrl(widgetType, tabs);
            var reqData = { _token: config.csrfToken };
            if (widgetType === 'tab_container' && tabs && tabs.length) {
                reqData.tabs = tabs;
            }
            var isPost = widgetType === 'tab_container' && tabs && tabs.length;
            var req = isPost
                ? $.ajax({ url: url, method: 'POST', data: reqData })
                : $.get(url);

            req.done(function (data) {
                var html = (data && typeof data === 'object' && data.html) ? data.html : null;
                if (!html || typeof html !== 'string') {
                    $body.html('<div class="text-muted text-center" style="padding: 20px;"><i class="fa fa-exclamation-triangle"></i> Widget non disponibile</div>');
                    return;
                }
                $body.find('.dashboard-v2-widget-loading').replaceWith(html);
                if (window.chartsHandler && typeof window.chartsHandler.initializeCharts === 'function') {
                    window.chartsHandler.initializeCharts();
                }
                if (typeof window.mountDashboardMyBrainIn === 'function') {
                    window.mountDashboardMyBrainIn($body[0]);
                }
                scheduleAutoResize();
            }).fail(function () {
                $body.find('.dashboard-v2-widget-loading').replaceWith(
                    '<div class="text-danger text-center" style="padding: 20px;"><i class="fa fa-exclamation-circle"></i> Errore caricamento widget</div>'
                );
            });
        }

        function loadAllWidgetsAsync() {
            $gridEl.find('.dashboard-v2-widget-body').each(function () {
                var $body = $(this);
                if (!$body.find('.dashboard-v2-widget-loading').length) return;
                var widgetType = $body.attr('data-widget-type');
                var widgetId = $body.attr('data-widget-id');
                var tabsJson = $body.attr('data-widget-tabs');
                var tabs = tabsJson ? (function () { try { return JSON.parse(tabsJson.replace(/&quot;/g, '"')); } catch (e) { return []; } })() : null;
                loadWidgetAsync($body, widgetType, widgetId, tabs);
            });
        }

        // ==================== Init & Event Binding ====================

        initGrid();
        if (config.asyncLoad) {
            loadAllWidgetsAsync();
        }
        scheduleAutoResize();

        $(window).on('load', function () {
            autoResizeWidgets();
        });

        $('#dashboard-v2-toggle-edit').on('click', toggleEditMode);
        $('#dashboard-v2-save-layout').on('click', saveLayout);

        $('#dashboard-v2-reset-layout').on('click', function () {
            if (!config.resetLayoutUrl) {
                return;
            }
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    title: 'Ripristinare il layout?',
                    text: 'Verranno ripristinati i widget predefiniti per questo workspace.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sì, ripristina',
                    cancelButtonText: 'Annulla'
                }).then(function (result) {
                    if (!result.isConfirmed) {
                        return;
                    }
                    $.ajax({
                        url: config.resetLayoutUrl,
                        method: 'POST',
                        data: { _token: config.csrfToken },
                        success: function () {
                            window.location.reload();
                        },
                        error: function () {
                            Swal.fire({ icon: 'error', title: 'Errore', text: 'Impossibile ripristinare il layout.' });
                        }
                    });
                });
            } else if (window.confirm('Ripristinare il layout predefinito?')) {
                $.ajax({
                    url: config.resetLayoutUrl,
                    method: 'POST',
                    data: { _token: config.csrfToken },
                    success: function () {
                        window.location.reload();
                    }
                });
            }
        });
        $('#dashboard-v2-add-widget-fab').on('click', openWidgetPicker);

        $(document).on('click', '#dashboard-v2-picker-add-selected', addSelectedWidgets);
        $(document).on('click', '.dashboard-v2-picker-cat-link', function (e) {
            e.preventDefault();
            var cat = $(this).attr('data-category');
            if (cat) {
                switchPickerCategory(cat);
            }
        });

        $(document).on('click', '.dashboard-v2-widget-remove', function () {
            var id = $(this).data('widget-id');
            if (id) {
                removeWidget(id);
            }
        });

        $(document).on('shown.bs.tab', '.dashboard-v2-tab-container a[data-toggle="tab"]', function () {
            autoResizeWidgets();
            setTimeout(autoResizeWidgets, 500);
        });

        $('#dashboard-v2-add-tab-container').on('click', addEmptyTabContainer);

        $(document).on('click', '.dashboard-v2-tab-add-widget', function () {
            var tabIndex = parseInt($(this).attr('data-tab-index'), 10);
            var gridItemId = $(this).closest('.grid-stack-item').attr('data-gs-id');
            if (gridItemId !== undefined && !isNaN(tabIndex)) {
                openTabWidgetPicker(gridItemId, tabIndex);
            }
        });

        $(document).on('click', '.dashboard-v2-tab-widget-remove', function (e) {
            e.stopPropagation();
            removeTabWidget($(this));
        });

        $(document).on('click', '.dashboard-v2-tab-add-btn', function (e) {
            e.preventDefault();
            var $container = $(this).closest('.dashboard-v2-tab-container');
            addNewTab($container);
        });

        $(document).on('dblclick', '.dashboard-v2-tab-label', function () {
            if (!isEditMode) {
                return;
            }
            renameTab($(this));
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
